module.exports = __webpack_public_path__ + "img/VE.a5efb17d.svg";